import { useInViewport, useRequest } from 'ahooks'
import { Button, Card, message, Row, Skeleton, Typography } from 'antd'
import get from 'lodash/get'
import {useHistory} from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'
import smartlookClient from 'smartlook-client'
import { checkAccess } from '../../Auth'
import { GMCCSpecials } from '../../GMCCCalculator/GMCCCalculator'
import { UR_Owner } from '../../State'
import AboutMe from './components/AboutMe'
import AffordabilityModal from './components/AffordabilityModal'
import Faq from './components/Faq'
import RootFooter from './components/Footer'
import MortgageRates from './components/MortgageRates'
import MyCompany from './components/MyCompany'
import PersonalInfoCard from './components/PersonalInfoCard'
import RequireCallback from './components/RequireCallback'
import Reviews from './components/Reviews'
import './index.css'
import { request } from '../../request'
import { shouldRecordSmartlook } from '../../utils'
import { ENUM_PERSONAL_SITE } from 'BlueratePersonalSite/enum'
import { getApplicationLink } from './applicationLink'

const { Text } = Typography

const BACKGROUND_COLOR = '#F7F8FC'
const RATE_QUOTE_DISABLED_LO_IDS = [
    '16c7cbfe-fe33-405f-9600-ad7308c52f49',
    '0c80c06c-1922-4c15-bd74-f6ff57e724bb',
]
const RATE_QUOTE_DISABLED_COMPANY_IDS = ['gmcc', 'changehomemortgage']

// Fix: public personal-site pages must resolve the profile from the URL
// customer/LO ids even when the viewer is signed in. Auth is only included
// for the embedded editor preview, where the profile should come from login state.
const getProfileRequestHeaders = ({ customerid, loid, includeAuthorization }) => {
    const headers = {
        Cache: 'no-cache',
    }

    if (includeAuthorization) {
        const token = sessionStorage.getItem('ZeitroA')
        if (token) {
            headers.Authorization = 'Bearer ' + token
        }
    }
    if (customerid) {
        headers['X-CustomerID'] = customerid
    }
    if (loid) {
        headers['X-LoID'] = loid
    }

    return headers
}

const LandingPage = (props) => {
    return <LoLandingPage {...props} />
}

const LoLandingPage = (props) => {
    const history = useHistory();

    //  编辑模式下可预览，预览模式只有激活的才能预览
    const NON_EDIT = props.mode !== "edit";

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [nmls, setNMLS] = useState('')
    const [phone, setPhone] = useState('')
    const [basicInfo, setBasicInfo] = useState({})
    const [aboutInfo, setAboutInfo] = useState({})
    const [reviewsList, setReviewsList] = useState([])
    const [loading, setLoading] = useState(true)
    const [showContactModal, setShowContactModal] = useState(false)
    const [companyLogoUrl, setCompanyLogoUrl] = useState('')
    const isOwner = checkAccess([UR_Owner])
    const [showFAQ, setShowFAQ] = useState(true)
    const [showTestimonial, setShowTestimonial] = useState(true)
    const [showAffordability, setShowAffordability] = useState(true)
    const [showMortgage, setShowMortgage] = useState(true)
    const [showCompanyInfo, setShowCompanyInfo] = useState(true)
    const [showGmccSpecials, setShowGmccSpecials] = useState(
        props.customerid === 'gmcc'
    )
    const [companyInfo, setCompanyInfo] = useState({})
    const [scale, setScale] = useState(0.8)
    const [pageWidth, setPageWidth] = useState(125)
    const [pageHeight, setPageHeight] = useState(125)

    const [landingUrl, setLandingUrl] = useState('')
    const [ratesData, setRatesData] = useState(null)
    const [navDrawer, setNavDrawer] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    const [showSideMenu, setShowSideMenu] = useState(false)
    const [showedModules, setShowedModules] = useState([])
    const [showPrivateLending, setShowPrivateLending] = useState(false)
    const [showPrivateLendingOnly, setShowPrivateLendingOnly] = useState(false)

    const [showFloatingButton, setShowFloatingButton] = useState(false)

    const [isPreviewMode, setIsPreviewMode] = useState(false)

    const [showQuickApplicationForm, setShowQuickApplicationForm] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop
            setShowFloatingButton(scrollTop > 300)
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const getIsNonQMCustomer = useCallback(async () => {
        try {
            setLoading(true)
            const response = await fetch('/los/nonqm/getaccountconfig', {
                method: 'GET',
                headers: {
                    'X-CustomerID': props.customerid,
                },
            })

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            const data = await response.json()
            setShowPrivateLending(
                data.isNonQMInclusive || data.isNonQMExclusive
            )
            setShowPrivateLendingOnly(data.isNonQMExclusive)
        } catch (error) {
            console.error('Error fetching account config:', error)
        } finally {
            setLoading(false)
        }
    }, [props.customerid])

    useEffect(() => {
        getIsNonQMCustomer()
    }, [getIsNonQMCustomer])

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search)
        if (searchParams.get('mode') === 'preview') {
            setIsPreviewMode(true)
        }
    }, [])

    const isEditMode = useMemo(() => props.mode === 'edit', [props.mode])

    const tabs = useMemo(
        () => [
            { key: 'aboutMe', label: 'About Me' },
            ...(showGmccSpecials
                ? [{ key: 'gmccSpecials', label: 'Specials' }]
                : []),
            ...(props.customerid !== 'googain' &&
            props.customerid !== 'gmcc' &&
            showMortgage
                ? [{ key: 'rates', label: 'Rates' }]
                : []),
            ...(props.customerid !== 'googain' &&
            props.customerid !== 'gmcc' &&
            !showMortgage &&
            showAffordability
                ? [{ key: 'affordability', label: 'Affordability' }]
                : []),
            ...(props.customerid !== 'googain' &&
            props.customerid !== 'gmcc' &&
            showCompanyInfo
                ? [{ key: 'myCompany', label: 'My Company' }]
                : []),
            ...((props.customerid === 'googain' ||
                props.customerid === 'gmcc') &&
            companyInfo.ShowRate
                ? [{ key: 'rates', label: 'Rates' }]
                : []),
            ...((props.customerid === 'googain' ||
                props.customerid === 'gmcc') &&
            !companyInfo.ShowRate &&
            companyInfo.ShowAffordability
                ? [{ key: 'affordability', label: 'Affordability' }]
                : []),
            ...((props.customerid === 'googain' ||
                props.customerid === 'gmcc') &&
            companyInfo.ShowCompanyInfo && showCompanyInfo
                ? [{ key: 'myCompany', label: 'My Company' }]
                : []),
            ...(showTestimonial ? [{ key: 'reviews', label: 'Reviews' }] : []),
            ...(showFAQ ? [{ key: 'faq', label: 'FAQ' }] : []),
            { key: 'requireCallback', label: 'Contact' },
        ],
        [
            showTestimonial,
            showFAQ,
            showCompanyInfo,
            showGmccSpecials,
            showMortgage,
            showAffordability,
            companyInfo,
            props.customerid,
        ]
    )

    const [activeTab, setActiveTab] = useState('aboutMe')
    const [isManualScrolling, setIsManualScrolling] = useState(false) // Track manual scrolling
    const [isFirstRender, setIsFirstRender] = useState(true)
    const initialRenderTimeoutRef = useRef(null)

    // Add refs for each section
    const containerRef = useRef(null)
    const aboutMeRef = useRef(null)
    const gmccSpecialsRef = useRef(null)
    const ratesRef = useRef(null)
    const affordabilityRef = useRef(null)
    const myCompanyRef = useRef(null)
    const reviewsRef = useRef(null)
    const faqRef = useRef(null)
    const requireCallbackRef = useRef(null)

    // Combine refs into an object
    const sectionRefs = useMemo(() => {
        const baseRefs = {
            aboutMe: aboutMeRef,
            requireCallback: requireCallbackRef,
        }

        if (props.customerid === 'googain' || props.customerid === 'gmcc') {
            // For Googain customers
            if (companyInfo.ShowRate) {
                baseRefs.rates = ratesRef
            }
            if (!companyInfo.ShowRate && companyInfo.ShowAffordability) {
                baseRefs.affordability = affordabilityRef
            }
            if (companyInfo.ShowCompanyInfo && showCompanyInfo) {
                baseRefs.myCompany = myCompanyRef
            }
        } else {
            // For non-Googain customers
            if (showMortgage) {
                baseRefs.rates = ratesRef
            }
            if (!showMortgage && showAffordability) {
                baseRefs.affordability = affordabilityRef
            }
            if (showCompanyInfo) {
                baseRefs.myCompany = myCompanyRef
            }
        }

        if (showTestimonial) {
            baseRefs.reviews = reviewsRef
        }

        if (showFAQ) {
            baseRefs.faq = faqRef
        }

        if (showGmccSpecials) {
            baseRefs.gmccSpecials = gmccSpecialsRef
        }

        return baseRefs
    }, [
        showTestimonial,
        showFAQ,
        showCompanyInfo,
        showMortgage,
        showAffordability,
        props.customerid,
        companyInfo,
    ])

    // Setup section visibility tracking for each section
    const [inViewportAbout, ratioAbout] = useInViewport(aboutMeRef, {
        root: containerRef.current,
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        rootMargin: '-1px 0px -1px 0px',
    })
    const [inViewportRates, ratioRates] = useInViewport(ratesRef, {
        root: containerRef.current,
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        rootMargin: '-1px 0px -1px 0px',
    })
    const [inViewportAffordability, ratioAffordability] = useInViewport(
        affordabilityRef,
        {
            root: containerRef.current,
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
            rootMargin: '-1px 0px -1px 0px',
        }
    )
    const [inViewportMyCompany, ratioMyCompany] = useInViewport(myCompanyRef, {
        root: containerRef.current,
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        rootMargin: '-1px 0px -1px 0px',
    })
    const [inViewportReviews, ratioReviews] = useInViewport(reviewsRef, {
        root: containerRef.current,
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        rootMargin: '-1px 0px -1px 0px',
    })
    const [inViewportFaq, ratioFaq] = useInViewport(faqRef, {
        root: containerRef.current,
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        rootMargin: '-1px 0px -1px 0px',
    })
    const [inViewportRequireCallback, ratioRequireCallback] = useInViewport(
        requireCallbackRef,
        {
            root: containerRef.current,
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
            rootMargin: '-1px 0px -1px 0px',
        }
    )
    const [inViewportGmccSpecials, ratioGmccSpecials] = useInViewport(
        gmccSpecialsRef,
        {
            root: containerRef.current,
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
            rootMargin: '-1px 0px -1px 0px',
        }
    )

    // Combine ratios into an object
    const sectionVisibility = useMemo(() => {
        const baseVisibility = {
            aboutMe: ratioAbout || 0,
            requireCallback: ratioRequireCallback || 0,
        }

        if (showMortgage) {
            baseVisibility.rates = ratioRates || 0
        }

        if (!showMortgage && showAffordability) {
            baseVisibility.affordability = ratioAffordability || 0
        }

        if (showCompanyInfo) {
            baseVisibility.myCompany = ratioMyCompany || 0
        }

        if (showTestimonial) {
            baseVisibility.reviews = ratioReviews || 0
        }

        if (showFAQ) {
            baseVisibility.faq = ratioFaq || 0
        }

        if (showGmccSpecials) {
            baseVisibility.gmccSpecials = ratioGmccSpecials || 0
        }

        return baseVisibility
    }, [
        ratioAbout,
        ratioRates,
        ratioAffordability,
        ratioMyCompany,
        ratioReviews,
        ratioFaq,
        ratioRequireCallback,
        showTestimonial,
        showFAQ,
        showCompanyInfo,
        showGmccSpecials,
        showMortgage,
    ])

    useEffect(() => {
        initialRenderTimeoutRef.current = setTimeout(() => {
            setActiveTab('aboutMe')
            setIsFirstRender(false)
        }, 1000)

        return () => {
            if (initialRenderTimeoutRef.current) {
                clearTimeout(initialRenderTimeoutRef.current)
            }
        }
    }, [])

    // Update active tab based on section visibility
    useEffect(() => {
        if (isManualScrolling || isFirstRender) return

        // Helper function to check if ratio is approximately 1
        const isFullyVisible = (ratio) => Math.abs(1 - ratio) < 0.01

        // Find first section with ratio = 1 or the highest ratio section
        const orderTabs = [
            'aboutMe',
            ...(showMortgage ? ['rates'] : []),
            ...(!showMortgage && showAffordability ? ['affordability'] : []),
            ...(showGmccSpecials ? ['gmccSpecials'] : []),
            ...(showCompanyInfo ? ['myCompany'] : []),
            ...(showTestimonial ? ['reviews'] : []),
            ...(showFAQ ? ['faq'] : []),
            'requireCallback',
        ]
        const maxVisibleSection = orderTabs.reduce((max, key) => {
            const currentRatio = sectionVisibility[key] || 0
            const maxRatio = max ? max.ratio : 0

            // If we already found a section with ratio = 1, keep it
            if (max && isFullyVisible(maxRatio)) {
                return max
            }

            // If current section has ratio = 1, return it immediately
            if (isFullyVisible(currentRatio)) {
                return { key, ratio: currentRatio }
            }

            // Otherwise, keep track of the highest ratio
            if (!max || currentRatio > maxRatio) {
                return { key, ratio: currentRatio }
            }

            return max
        }, null)

        // Update active tab if we have a visible section
        if (maxVisibleSection && maxVisibleSection.ratio > 0) {
            setActiveTab(maxVisibleSection.key)
        }
    }, [
        sectionVisibility,
        isManualScrolling,
        isFirstRender,
        showTestimonial,
        showFAQ,
        showCompanyInfo,
        showGmccSpecials,
        showMortgage,
        showAffordability,
    ])

    useEffect(() => {
        const showModules = ['aboutMe']
        if (props.customerid === 'gmcc') {
            showModules.push('gmccSpecials')
        }
        if (
            props.customerid !== 'googain' &&
            props.customerid !== 'gmcc' &&
            showMortgage
        ) {
            showModules.push('rates')
        }
        if (
            (props.customerid === 'googain' || props.customerid === 'gmcc') &&
            companyInfo.ShowRate
        ) {
            showModules.push('rates')
        }
        if (
            props.customerid !== 'googain' &&
            props.customerid !== 'gmcc' &&
            !showMortgage &&
            showAffordability
        ) {
            showModules.push('affordability')
        }
        if (
            (props.customerid === 'googain' || props.customerid === 'gmcc') &&
            !companyInfo.ShowRate &&
            companyInfo.ShowAffordability
        ) {
            showModules.push('affordability')
        }
        if (
            props.customerid !== 'googain' &&
            props.customerid !== 'gmcc' &&
            showCompanyInfo
        ) {
            showModules.push('myCompany')
        }
        if (
            (props.customerid === 'googain' || props.customerid === 'gmcc') &&
            companyInfo.ShowCompanyInfo && showCompanyInfo
        ) {
            showModules.push('myCompany')
        }
        if (props.customerid !== 'googain' && showTestimonial) {
            showModules.push('reviews')
        }
        if (showFAQ) {
            showModules.push('faq')
        }
        showModules.push('requireCallback')
        setShowedModules(showModules)
    }, [
        showTestimonial,
        showFAQ,
        showCompanyInfo,
        showGmccSpecials,
        showMortgage,
        showAffordability,
        companyInfo,
        props.customerid,
    ])

    // Scroll to the specified section
    // const scrollToSection = useCallback(
    //     (key) => {
    //         const container = containerRef.current
    //         const targetSection = sectionRefs[key]?.current

    //         if (container && targetSection) {
    //             // Set manual scrolling flag and update active tab immediately
    //             setIsManualScrolling(true)
    //             setActiveTab(key)

    //             // Calculate the actual offset of the target section relative to the container
    //             const containerRect = container.getBoundingClientRect()
    //             const targetRect = targetSection.getBoundingClientRect()
    //             const relativeOffset =
    //                 (targetRect.top - containerRect.top) / scale +
    //                 container.scrollTop

    //             // Add scrollend event listener
    //             const handleScrollEnd = () => {
    //                 setIsManualScrolling(false)
    //                 container.removeEventListener('scrollend', handleScrollEnd)
    //             }
    //             container.addEventListener('scrollend', handleScrollEnd)

    //             // Scroll to the target section
    //             container.scrollTo({ top: relativeOffset, behavior: 'smooth' })
    //         }
    //     },
    //     [sectionRefs, scale]
    // )

    const isScrollableContainer = useCallback((element) => {
        if (!element) return false

        return element.scrollHeight > element.clientHeight + 1
    }, [])

    // updated scrollToSection logic for adapting non-scrollable navigation panel
    const scrollToSection = useCallback(
        (key) => {
            const targetSection = sectionRefs[key]?.current
    
            if (targetSection) {
                // Set manual scrolling flag and update active tab immediately
                setIsManualScrolling(true)
                setActiveTab(key)

                const container = containerRef.current
                const headerOffset = isMobile ? 16 : 30
                const resetManualScrolling = () => {
                    setIsManualScrolling(false)
                }

                if (isScrollableContainer(container)) {
                    const containerRect = container.getBoundingClientRect()
                    const targetRect = targetSection.getBoundingClientRect()
                    const scrollTop =
                        container.scrollTop +
                        targetRect.top -
                        containerRect.top -
                        headerOffset

                    container.scrollTo({ top: scrollTop, behavior: 'smooth' })
                    if (
                        containerRect.bottom <= 0 ||
                        containerRect.top >= window.innerHeight
                    ) {
                        window.scrollTo({
                            top:
                                window.pageYOffset +
                                containerRect.top -
                                headerOffset,
                            behavior: 'smooth',
                        })
                    }
                    window.setTimeout(resetManualScrolling, 500)
                    return
                }

                // Get the target section's position relative to the viewport
                const targetRect = targetSection.getBoundingClientRect()

                // Calculate the scroll position needed to bring the section to the top
                // Account for any fixed headers or navigation
                const scrollTop = window.pageYOffset + targetRect.top - headerOffset

                window.scrollTo({ top: scrollTop, behavior: 'smooth' })
                window.setTimeout(resetManualScrolling, 500)
            }
        },
        [sectionRefs, isMobile, isScrollableContainer]
    )

    const handleRatesUpdate = useCallback((data) => {
        setRatesData(data)
    }, [])

    const adjustZoom = useCallback(() => {
        const windowWidth = window.innerWidth
        setIsMobile(windowWidth < 768)
        if (windowWidth < 768) {
            setScale(1)
            setPageWidth('100%')
            setPageHeight('100%')
            return
        }

        const minWidth = 1200
        let availableWidth = isEditMode ? windowWidth / 2 : windowWidth
        // Subtract the right margin and horizontal padding
        availableWidth = availableWidth - 24 - 24 * 2
        const newScale = Math.min(availableWidth / minWidth, 1)
        setScale(newScale)
        setPageWidth(newScale < 1 ? `${100 / newScale}%` : '100%')
        setPageHeight(newScale < 1 ? `${100 / newScale}%` : '100%')
    }, [])

    useEffect(() => {
        getLoanOfficerProfile()
    }, [])

    useEffect(() => {
        adjustZoom()

        const handleResize = () => {
            adjustZoom()
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [adjustZoom])

    const initialPropsRef = useRef({
        basicInfo: props.basicInfo,
        aboutInfo: props.aboutInfo,
    })

    useEffect(() => {
        const { basicInfo, aboutInfo } = initialPropsRef.current

        const shouldUpdateBasicInfo =
            JSON.stringify(basicInfo) !== JSON.stringify(props.basicInfo)
        const shouldUpdateAboutInfo =
            JSON.stringify(aboutInfo) !== JSON.stringify(props.aboutInfo)
        if (isEditMode) {
            if (shouldUpdateBasicInfo) {
                setBasicInfo((basicInfo) => ({
                    ...basicInfo,
                    file:
                        props.basicInfo.file.length > 0
                            ? [{ url: props.basicInfo.file[0].url }]
                            : undefined,
                    firstname: props.basicInfo.firstname,
                    lastname: props.basicInfo.lastname,
                    nmls: props.basicInfo.nmls,
                    states: props.basicInfo.states,
                    stateCapabilities: props.basicInfo.stateCapabilities,
                    languages: props.basicInfo.languages,
                    tagsList: props.basicInfo.tagsList,
                    popularTags: [
                        'I speak Mandarin',
                        'Self-Employed borrowers',
                        'Bay Area for 10+ years',
                    ],
                    google: props.basicInfo.google,
                    yelp: props.basicInfo.yelp,
                    linkedin: props.basicInfo.linkedin,
                    twitter: props.basicInfo.twitter,
                    helocLink: props.basicInfo.helocLink,
                    heloanLink: props.basicInfo.heloanLink,
                    showHomeEquity: props.basicInfo.showHomeEquity,
                }))
            }
            if (shouldUpdateAboutInfo) {
                setAboutInfo((aboutInfo) => ({
                    ...aboutInfo,
                    introduction: props.aboutInfo.introduction,
                    companyLogo: props.aboutInfo.companyLogo,
                    companyName: props.aboutInfo.companyName,
                    companyAddress: props.aboutInfo.companyAddress,
                    phone: props.aboutInfo.phone,
                    email: props.aboutInfo.email,
                    companyWebsite: props.aboutInfo.companyWebsite,
                    tagline: props.aboutInfo.tagline,

                    companyIntroduction: props.aboutInfo.companyIntroduction,
                    companyLink: props.aboutInfo.companyLink,
                    banner: props.aboutInfo.banner,
                }))
            }

            if (shouldUpdateBasicInfo || shouldUpdateAboutInfo) {
                initialPropsRef.current = {
                    basicInfo: props.basicInfo,
                    aboutInfo: props.aboutInfo,
                }
            }
        }
    }, [props.basicInfo, props.aboutInfo])

    useEffect(() => {
        if (isEditMode) {
            setShowFAQ(getModuleStatus(4, 'FAQs'))
            setShowTestimonial(getModuleStatus(4, 'testimonial'))
            setShowAffordability(getModuleStatus(3, 'affordability'))
            setShowMortgage(getModuleStatus(3, 'mortgage'))
        }
    }, [props.moduleManage])

    useEffect(() => {
        if (isEditMode) {
            setShowCompanyInfo(props.companyInfoDisable)
        }
    }, [props.companyInfoDisable])

    useEffect(() => {
        if (isEditMode) {
            setReviewsList(props.reviewList)
        }
    }, [props.reviewList])

    useEffect(() => {
        if (isEditMode) {
            setAboutInfo((aboutInfo) => ({
                ...aboutInfo,
                paramsInfo: props.paramsInfo,
                faqInfo: props.faqInfo,
            }))
        }
    }, [props.paramsInfo, props.faqInfo])

    const getModuleStatus = useCallback(
        (num, key) => {
            return props.moduleManage
                .find((module) => module.module === num)
                .manage.find((item) => item.key === key).status
        },
        [props.moduleManage]
    )

    const handleSubmit = useCallback((type) => {
        if (type === 'success') {
            setShowContactModal(false)
            message.success(
                'Thanks for your submission. We will contact you shortly.'
            )
        } else {
            message.error(
                'Some internal error happened. Please try again later.'
            )
        }
    }, [])

    const showDrawer = useCallback(() => {
        setNavDrawer(!navDrawer)
    }, [navDrawer])

    const onClose = useCallback(() => {
        setNavDrawer(false)
    }, [])

    const dynamicExternalLink = useCallback((href) => {
        if (!/^https?:\/\//i.test(href)) {
            return `https://${href}`
        }
        return href
    }, [])

    const getPreQualificationLink = (withLeadsChannel = false) =>
        getApplicationLink({
            customerid: props.customerid,
            loid: props.loid,
            appLink: basicInfo.appLink,
            appUrl: props.appurl,
            leadsChannel: withLeadsChannel
                ? 'personalsite-prequalify-today'
                : undefined,
        })

    const preQualificationLink = useMemo(
        () => getPreQualificationLink(false),
        [basicInfo.appLink, props.appurl, props.customerid, props.loid]
    )
    const preQualifyTodayLink = useMemo(
        () => getPreQualificationLink(true),
        [basicInfo.appLink, props.appurl, props.customerid, props.loid]
    )

    const nonQMApplicationLink = useMemo(() => {
        return `${props.appurl}/services/privatelending/signup/${props.customerid}`
    }, [props.appurl, props.customerid])

    const getCompanyProfile = useCallback(async () => {
        try {
            setLoading(true)
            const response = await fetch('/los/getcompanyprofilesetup', {
                cache: 'no-cache',
                method: 'GET',
                headers: getProfileRequestHeaders({
                    customerid: props.customerid,
                    includeAuthorization: isEditMode,
                }),
            })

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            return response.json()
        } catch (error) {
            console.error('Error fetching company profile:', error)
        } finally {
            setLoading(false)
        }
    }, [isEditMode, props.customerid])

    const { run: getLoanOfficerProfile } = useRequest(
        async () => {
            try {
                if (NON_EDIT) {
                    const { status } = await request(`/los/getverifystatusbyid?id=${props.loid}`);
                    if (status !== ENUM_PERSONAL_SITE.STATUS.ACTIVATED) {
                      return history.replace('/404');
                    }
                }
                setLoading(true)
                const companyProfile = await getCompanyProfile()
                const response = await fetch('/los/getprofilesetup', {
                    cache: 'no-cache',
                    method: 'GET',
                    headers: getProfileRequestHeaders({
                        customerid: props.customerid,
                        loid: props.loid,
                        includeAuthorization: isEditMode,
                    }),
                })

                if (!response.ok) {
                    throw new Error(
                        'Failed to get loan officer profile:',
                        response
                    )
                }

                const data = await response.json()
                
                return {
                    data,
                    companyProfile,
                }
            } catch (error) {
                console.error('Get loan officer profile exception:', error)
            }
        },
        {
            manual: true,
            refreshOnWindowFocus: isPreviewMode,
            focustTimespan: 5000,
            onSuccess: (result) => {
                const { data, companyProfile } = result
                const setup = data.LandingPageSetUp
                const draft =
                    !isEditMode && !isPreviewMode ? {} : get(setup, 'draft', {})

                const landingPageSetup = draft.LandingPageSetUp || setup

                if (shouldRecordSmartlook()) {
                    smartlookClient.init('09b3763f18ea03a3078dade87fcf17e136934224')
                    smartlookClient.record({
                        emails: true,
                        forms: true,
                        numbers: true,
                        ips: true,
                    })
                    smartlookClient.identify(props.loid, {
                        name: `${data.FirstName} ${data.LastName}`,
                        email: data.Email,
                    })
                }

                setCompanyLogoUrl(data.CompanyLogo || companyProfile.Logo)
                setShowQuickApplicationForm(landingPageSetup?.showQuickApplicationForm || false)
                sessionStorage.setItem('showQuickApplicationForm', landingPageSetup?.showQuickApplicationForm || false)
                setShowFAQ(get(landingPageSetup, 'showFAQ', true))
                setShowTestimonial(
                    get(landingPageSetup, 'showTestimonial', false)
                )
                setShowMortgage(get(landingPageSetup, 'showMortgage', true))
                setShowAffordability(
                    get(landingPageSetup, 'showAffordability', true)
                )

                const firstName = get(draft, 'FirstName', data.FirstName)
                const lastName = get(draft, 'LastName', data.LastName)
                setName(`${firstName} ${lastName}`)
                const image = get(draft, 'Image', data.Image)
                setBasicInfo({
                    file: isEmpty(image) ? [] : [{ url: image }],
                    firstname: firstName,
                    lastname: lastName,
                    loemail: data.Email,
                    nmls: draft.NMLS || data.NMLS,
                    states: get(landingPageSetup, 'States', []),
                    stateCapabilities: get(
                        landingPageSetup,
                        'StateCapabilities',
                        []
                    ),
                    languages: get(landingPageSetup, 'Languages', []),
                    tagsList: get(landingPageSetup, 'TagsList', []),
                    popularTags: [
                        'I speak Mandarin',
                        'Self-Employed borrowers',
                        'Bay Area for 10+ years',
                    ],
                    google: get(landingPageSetup, 'Google', ''),
                    yelp: get(landingPageSetup, 'Yelp', ''),
                    linkedin: get(landingPageSetup, 'Linkedin', ''),
                    twitter: get(landingPageSetup, 'Twitter', ''),
                    appLink: get(landingPageSetup, 'appLink', ''),
                    helocLink: get(landingPageSetup, 'helocLink', ''),
                    heloanLink: get(landingPageSetup, 'heloanLink', ''),
                    showHomeEquity: get(
                        landingPageSetup,
                        'showHomeEquity',
                        false
                    ),
                })

                setEmail(data.Email)
                setPhone(get(draft, 'Phone', data.Phone))
                setNMLS(get(draft, 'NMLS', data.NMLS))

                setAboutInfo({
                    introduction: get(draft, 'Introduction', data.Introduction),
                    phone: get(draft, 'Phone', data.Phone),
                    email: get(landingPageSetup, 'Email', data.Email || ''),
                    tagline: get(landingPageSetup, 'tagline', ''),
                    companyName: get(
                        landingPageSetup,
                        'CompanyName',
                        data.CompanyName || companyProfile.Name || ''
                    ),
                    companyLink: get(
                        landingPageSetup,
                        'companyLink',
                        companyProfile.Link || ''
                    ),
                    banner: get(
                        landingPageSetup,
                        'banner',
                        companyProfile.Banner || ''
                    ),
                    companyWebsite: get(landingPageSetup, 'CompanyWebsite', ''),
                    companyIntroduction: get(
                        landingPageSetup,
                        'companyIntroduction',
                        companyProfile.Introduction || ''
                    ),
                    companyAddress: get(
                        landingPageSetup,
                        'companyAddress',
                        data.CompanyAddress || companyProfile.Address || ''
                    ),
                    companyLogo: data.CompanyLogo || companyProfile.Logo,
                    paramsInfo: get(landingPageSetup, 'paramsInfo', {
                        title: '',
                        paramsList: [],
                    }),
                    faqInfo: get(landingPageSetup, 'faqInfo', []),
                })

                setReviewsList(get(landingPageSetup, 'ReviewsList', []))

                setLandingUrl(
                    window.location.hostname.includes('localhost')
                        ? `http://localhost:3001${data.LandingUrl}`
                        : `https://${window.location.hostname}${data.LandingUrl}`
                )

                setShowCompanyInfo(
                    get(landingPageSetup, 'showCompanyInfo', true)
                )
                setCompanyInfo(companyProfile)
            },
            onError: (error) => {
                console.error('Failed to get loan officer profile:', error)
            },
            onFinally: () => {
                setLoading(false)
            },
        }
    )

    if (loading) {
        return (
            <div className="p-4">
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
            </div>
        )
    }

    if (isMobile) {
        return (
            <div
                style={{
                    backgroundColor: '#eef1f4',
                    paddingLeft: '14px',
                    paddingRight: '14px',
                    width: '100%',
                    overflow: 'hidden',
                }}
            >
                {/* SEO Automation */}
                {NON_EDIT && <Helmet>
                    <title>{name}'s Loan Services</title>
                    <meta
                        name="title"
                        content={`Personalized Mortgage Rates with ${name} | Trusted Home Loans from My Mortgage Rate`}
                    />
                    <meta
                        name="description"
                        content={`Get custom mortgage rates with ${name} on My Mortgage Rate. Easily compare lenders, read reviews, and secure low-rate home loans with expert guidance.`}
                    />
                    <link
                        rel="icon"
                        href={
                            basicInfo.file?.[0]?.url ||
                            aboutInfo.companyLogo ||
                            '/images/smalllogo.svg'
                        }
                    />
                </Helmet>}

                {/* Header */}
                <Row
                    className="landing-page-header"
                    style={{
                        marginLeft: '-14px',
                        marginRight: '-14px',
                        width: 'calc(100% + 28px)',
                    }}
                >
                    <img
                        src={aboutInfo.companyLogo || '/images/logo.svg'}
                        alt="Zeitro Marketplace"
                        priority="true"
                        height={35}
                    />
                    <div className="d-flex flex-column">
                        {showPrivateLending && (
                            <Button
                                type="landing-apply-now mb-3"
                                onClick={() => {
                                    window.open(nonQMApplicationLink, '_blank')
                                }}
                            >
                                Investor Portal
                            </Button>
                        )}

                        {!showPrivateLendingOnly && (
                            <Button
                                type="landing-apply-now"
                                onClick={() => {
                                    if (isEditMode) return;
                                    window.open(preQualificationLink, '_blank')
                                }}
                            >
                                Apply now
                            </Button>
                        )}
                    </div>
                </Row>

                {/* Hamburger Menu Button */}
                <button
                    onClick={() => setShowSideMenu(true)}
                    style={{
                        boxSizing: 'content-box',
                        border: 'none',
                        background: 'none',
                        outline: 'none',
                        padding: '6px 0',
                        cursor: 'pointer',
                    }}
                >
                    <img
                        src="/images/hamburger.svg"
                        alt="Hamburger"
                        style={{
                            width: '40px',
                            height: '40px',
                        }}
                    />
                </button>

                {/* Hamburger Sidebar Menu */}
                <div
                    className="hamburger-sidebar"
                    style={{
                        opacity: showSideMenu ? 1 : 0,
                        pointerEvents: showSideMenu ? 'auto' : 'none',
                    }}
                    onClick={() => setShowSideMenu(false)}
                >
                    <div
                        className="side-menu"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            right: 0,
                            left: 'auto',
                            transform: `translateX(${
                                showSideMenu ? '0' : '100%'
                            })`,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                paddingTop: '81px',
                                paddingRight: '38px',
                            }}
                        >
                            {tabs.map((tab) => (
                                <button
                                    key={tab.key}
                                    style={{
                                        padding: '16px',
                                        textAlign: 'right',
                                        fontSize: '18px',
                                        lineHeight: '21.78px',
                                        color:
                                            activeTab === tab.key
                                                ? '#325ceb'
                                                : '#000000',
                                        fontWeight:
                                            activeTab === tab.key
                                                ? '500'
                                                : '400',
                                    }}
                                    onClick={() => {
                                        scrollToSection(tab.key)
                                        setShowSideMenu(false)
                                    }}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                <div
                    ref={containerRef}
                    className="card-container"
                    style={{
                        height: isEditMode ? '100%' : 'calc(100vh - 130px)',
                        marginBottom: '-40px',
                        border: 'none',
                        boxShadow: 'none',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                    }}
                >
                    {/* Personal Info Card */}
                    <PersonalInfoCard
                        info={{
                            customerid: props.customerid,
                            loid: props.loid,
                            showQuickApplicationForm: showQuickApplicationForm,
                        }}
                        aboutInfo={aboutInfo}
                        basicInfo={basicInfo}
                        contact={() => scrollToSection('requireCallback')}
                        preQualify={() =>
                          isEditMode || window.open(preQualifyTodayLink, '_blank')
                        }
                        isMobile={true}
                        showSideMenu={showSideMenu}
                    />

                    {/* Sections Card */}
                    <div style={{ borderRadius: '10px' }}>
                        <Card className="sections-card">
                            <div style={{ borderRadius: '10px' }}>
                                {/* About Me Section */}
                                <div ref={aboutMeRef}>
                                    <AboutMe
                                        aboutInfo={aboutInfo}
                                        basicInfo={basicInfo}
                                        isMobile={true}
                                    />
                                </div>

                                {/* GMCC Specials Section */}
                                {showGmccSpecials && (
                                    <div ref={gmccSpecialsRef}>
                                        <GMCCSpecials
                                            fromLanding={true}
                                            customerid={props.customerid}
                                            loid={props.loid}
                                            url={props.Url}
                                        />
                                    </div>
                                )}

                                {/* Mortgage Rates Section */}
                                {showMortgage ? (
                                    <div ref={ratesRef}>
                                        <MortgageRates
                                            showQuickApplicationForm={showQuickApplicationForm}
                                            firstName={basicInfo.firstname}
                                            customerid={props.customerid}
                                            loid={props.loid}
                                            appLink={basicInfo.appLink}
                                            companyLink={props.companyLink}
                                            helocLink={basicInfo.helocLink}
                                            heloanLink={basicInfo.heloanLink}
                                            showHomeEquity={
                                                basicInfo.showHomeEquity
                                            }
                                            onRatesUpdate={handleRatesUpdate}
                                            showAffordability={
                                                showAffordability
                                            }
                                            isPreviewMode={isEditMode}
                                            loanOfficerEmail={
                                                basicInfo?.loemail
                                            }
                                            licensedStates={basicInfo.states}
                                            stateCapabilities={
                                                basicInfo.stateCapabilities
                                            }
                                            loName={`${basicInfo.firstname || ''} ${basicInfo.lastname || ''}`.trim()}
                                            onContact={() =>
                                                setShowContactModal(true)
                                            }
                                            isMobile={true}
                                        />
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            borderBottom: '1px solid #ECECEC',
                                            marginLeft: '20px',
                                            marginRight: '20px',
                                        }}
                                    />
                                )}

                                {/* Affordability Section */}
                                {!showMortgage && showAffordability && (
                                    <>
                                        <div
                                            style={{
                                                borderBottom:
                                                    '1px solid #ECECEC',
                                                marginLeft: '30px',
                                                marginRight: '30px',
                                            }}
                                        />
                                        <div ref={affordabilityRef}>
                                            <AffordabilityModal
                                                showQuickApplicationForm={showQuickApplicationForm}
                                                isFromLanding={true}
                                                customerid={props.customerid}
                                                loid={props.loid}
                                                appLink={basicInfo.appLink}
                                                companyLink={props.companyLink}
                                                isMobile={true}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                borderBottom:
                                                    '1px solid #ECECEC',
                                                marginLeft: '30px',
                                                marginRight: '30px',
                                            }}
                                        />
                                    </>
                                )}

                                {/* My Company Section */}
                                {showCompanyInfo && (
                                    <div ref={myCompanyRef}>
                                        <MyCompany
                                            aboutInfo={aboutInfo}
                                            loanOfficerEmail={
                                                basicInfo?.loemail
                                            }
                                            isMobile={true}
                                            companyInfo={companyInfo}
                                            customerID={props.customerid}
                                        />
                                    </div>
                                )}

                                {/* Reviews Section */}
                                {showTestimonial && (
                                    <div ref={reviewsRef}>
                                        <Reviews
                                            reviewsList={reviewsList}
                                            loanOfficerEmail={
                                                basicInfo?.loemail
                                            }
                                            isMobile={true}
                                        />
                                    </div>
                                )}

                                {/* FAQ Section */}
                                {showFAQ && (
                                    <div ref={faqRef}>
                                        <Faq
                                            faqInfo={aboutInfo.faqInfo}
                                            loanOfficerEmail={
                                                basicInfo?.loemail
                                            }
                                            isMobile={true}
                                        />
                                    </div>
                                )}

                                {/* Require Callback Section */}
                                <div ref={requireCallbackRef}>
                                    <RequireCallback
                                        loid={props.loid}
                                        customerid={props.customerid}
                                        handleSubmit={handleSubmit}
                                        ratesData={ratesData}
                                        isPreviewMode={isEditMode}
                                        loanOfficerEmail={basicInfo?.loemail}
                                        isMobile={true}
                                    />
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>

                {/* Back to the top */}
                <div
                    className="back-to-top"
                    onClick={() => {
                        if (containerRef.current) {
                            containerRef.current.scrollTo({
                                top: 0,
                                behavior: 'smooth',
                            })
                        }
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                >
                    <Text
                        style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            lineHeight: '19px',
                            color: '#858585',
                            marginRight: '11px',
                        }}
                    >
                        Back to the top
                    </Text>
                    <img
                        src="/images/arrow-up.svg"
                        alt="Back to the top"
                        style={{ width: '12px', height: '8px' }}
                    />
                </div>

                {/* Footer */}
                <div
                    style={{
                        marginLeft: '-14px',
                        marginRight: '-14px',
                        width: 'calc(100% + 28px)',
                    }}
                >
                    <RootFooter
                        scrollToSection={scrollToSection}
                        basicInfo={basicInfo}
                        aboutInfo={aboutInfo}
                        customerID={props.customerid}
                        showedModules={showedModules}
                    />
                </div>
            </div>
        )
    }

    return (
        <>
        <div
            ref={containerRef}
            className="landing-page-container"
            style={{
                transform: `scale(${scale})`,
                transformOrigin: 'top left',
                width: pageWidth,
                height: isEditMode ? pageHeight : 'auto',
                overflowY: isEditMode ? 'scroll' : 'auto',
            }}
        >
            {/* SEO Automation */}
            {NON_EDIT && <Helmet>
                <title>{name}'s Loan Services</title>
                <meta
                    name="title"
                    content={`Personalized Mortgage Rates with ${name} | Trusted Home Loans from My Mortgage Rate`}
                />
                <meta
                    name="description"
                    content={`Get custom mortgage rates with ${name} on My Mortgage Rate. Easily compare lenders, read reviews, and secure low-rate home loans with expert guidance.`}
                />
                <link
                    rel="icon"
                    href={
                        basicInfo.file?.[0]?.url ||
                        aboutInfo.companyLogo ||
                        '/images/smalllogo.svg'
                    }
                />
            </Helmet>}

            {/* Header */}
            <Row className="landing-page-header">
                <img
                    src={aboutInfo.companyLogo || '/images/logo.svg'}
                    alt="Zeitro Marketplace"
                    priority="true"
                    height={35}
                />
                <div>
                    {showPrivateLending && (
                        <Button
                            type="landing-apply-now mr-3"
                            onClick={() => {
                                window.open(nonQMApplicationLink, '_blank')
                            }}
                        >
                            Investor Portal
                        </Button>
                    )}
                    {!showPrivateLendingOnly && (
                        <Button
                            type="landing-apply-now"
                            onClick={() => {
                                if (isEditMode) return;
                                window.open(preQualificationLink, '_blank')
                            }}
                        >
                            Apply now
                        </Button>
                    )}
                </div>
            </Row>

            <div className="landing-page-content">
                {/* Personal Info Card */}
                <PersonalInfoCard
                    info={{
                        customerid: props.customerid,
                        loid: props.loid,
                        showQuickApplicationForm: showQuickApplicationForm,
                    }}
                    aboutInfo={aboutInfo}
                    basicInfo={basicInfo}
                    contact={() => scrollToSection('requireCallback')}
                    preQualify={() =>
                        isEditMode || window.open(preQualifyTodayLink, '_blank')
                    }
                />

                {/* Tabs Navigation Bar */}
                <div className="navigation-container">
                    <div className="tabs-navigation">
                        {tabs.map((tab, index) => (
                            <div
                                key={tab.key}
                                className={`tab-item ${
                                    activeTab === tab.key
                                        ? 'tab-item-active'
                                        : 'tab-item-inactive'
                                } ${index === 0 ? 'first-tab' : ''} ${
                                    index === tabs.length - 1 ? 'last-tab' : ''
                                }`}
                                onClick={() => {
                                    scrollToSection(tab.key)
                                }}
                            >
                                {tab.label}
                            </div>
                        ))}
                    </div>

                    {/* Card Container */}
                    <Card
                        // ref={containerRef}
                        className="card-container"
                        style={{
                            // height: isEditMode ? '100%' : 'calc(100vh - 130px)',
                            height: 'fit-content',
                            marginBottom: '-40px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderBottomLeftRadius: '10px',
                                borderBottomRightRadius: '10px',
                            }}
                        >
                            {/* About Me Section */}
                            <div ref={aboutMeRef}>
                                <AboutMe
                                    aboutInfo={aboutInfo}
                                    basicInfo={basicInfo}
                                />
                            </div>

                            {/* GMCC Specials Section */}
                            {showGmccSpecials && (
                                <div ref={gmccSpecialsRef}>
                                    <GMCCSpecials
                                        showQuickApplicationForm={showQuickApplicationForm}
                                        fromLanding={true}
                                        customerid={props.customerid}
                                        loid={props.loid}
                                        url={props.Url}
                                    />
                                </div>
                            )}

                            {/* Mortgage Rates Section */}
                            {props.customerid !== 'googain' &&
                            props.customerid !== 'gmcc' &&
                            showMortgage ? (
                                <div ref={ratesRef}>
                                    <MortgageRates
                                        showQuickApplicationForm={showQuickApplicationForm}
                                        firstName={basicInfo.firstname}
                                        customerid={props.customerid}
                                        loid={props.loid}
                                        appLink={basicInfo.appLink}
                                        companyLink={props.companyLink}
                                        helocLink={basicInfo.helocLink}
                                        heloanLink={basicInfo.heloanLink}
                                        showHomeEquity={basicInfo.showHomeEquity}
                                        onRatesUpdate={handleRatesUpdate}
                                        showAffordability={showAffordability}
                                        isPreviewMode={isEditMode}
                                        loanOfficerEmail={basicInfo?.loemail}
                                        licensedStates={basicInfo.states}
                                        stateCapabilities={
                                            basicInfo.stateCapabilities
                                        }
                                        loName={`${basicInfo.firstname || ''} ${basicInfo.lastname || ''}`.trim()}
                                        onContact={() =>
                                            setShowContactModal(true)
                                        }
                                    />
                                </div>
                            ) : (
                                <div
                                    style={{
                                        borderBottom: '1px solid #ECECEC',
                                        marginLeft: '30px',
                                        marginRight: '30px',
                                    }}
                                />
                            )}

                            {/* Affordability Section */}
                            {props.customerid !== 'googain' &&
                                props.customerid !== 'gmcc' &&
                                !showMortgage &&
                                showAffordability && (
                                    <>
                                        <div ref={affordabilityRef}>
                                            <AffordabilityModal
                                                showQuickApplicationForm={showQuickApplicationForm}
                                                isFromLanding={true}
                                                customerid={props.customerid}
                                                loid={props.loid}
                                                appLink={basicInfo.appLink}
                                                companyLink={props.companyLink}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                borderBottom:
                                                    '1px solid #ECECEC',
                                                marginLeft: '30px',
                                                marginRight: '30px',
                                            }}
                                        />
                                    </>
                                )}

                            {/* My Company Section */}
                            {props.customerid !== 'googain' &&
                                props.customerid !== 'gmcc' &&
                                showCompanyInfo && (
                                    <div ref={myCompanyRef}>
                                        <MyCompany
                                            aboutInfo={aboutInfo}
                                            loanOfficerEmail={
                                                basicInfo?.loemail
                                            }
                                            companyInfo={companyInfo}
                                            customerID={props.customerid}
                                        />
                                    </div>
                                )}

                            {/* Googain Mortgage Rates Section */}
                            {(props.customerid === 'googain' ||
                                props.customerid === 'gmcc') &&
                                companyInfo.ShowRate && (
                                    <div ref={ratesRef}>
                                        <MortgageRates
                                            showQuickApplicationForm={showQuickApplicationForm}
                                            firstName={basicInfo.firstname}
                                            customerid={props.customerid}
                                            loid={props.loid}
                                            appLink={basicInfo.appLink}
                                            companyLink={props.companyLink}
                                            helocLink={basicInfo.helocLink}
                                            heloanLink={basicInfo.heloanLink}
                                            showHomeEquity={
                                                basicInfo.showHomeEquity
                                            }
                                            onRatesUpdate={handleRatesUpdate}
                                            showAffordability={
                                                companyInfo.ShowAffordability
                                            }
                                            isPreviewMode={isEditMode}
                                            loanOfficerEmail={
                                                basicInfo?.loemail
                                            }
                                            licensedStates={basicInfo.states}
                                            stateCapabilities={
                                                basicInfo.stateCapabilities
                                            }
                                            loName={`${basicInfo.firstname || ''} ${basicInfo.lastname || ''}`.trim()}
                                            onContact={() =>
                                                setShowContactModal(true)
                                            }
                                        />
                                    </div>
                                )}

                            {/*Googain Affordability Section */}
                            {(props.customerid === 'googain' ||
                                props.customerid === 'gmcc') &&
                                !companyInfo.ShowRate &&
                                companyInfo.ShowAffordability && (
                                    <>
                                        <div ref={affordabilityRef}>
                                            <AffordabilityModal
                                                showQuickApplicationForm={showQuickApplicationForm}
                                                isFromLanding={true}
                                                customerid={props.customerid}
                                                loid={props.loid}
                                                appLink={basicInfo.appLink}
                                                companyLink={props.companyLink}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                borderBottom:
                                                    '1px solid #ECECEC',
                                                marginLeft: '30px',
                                                marginRight: '30px',
                                            }}
                                        />
                                    </>
                                )}

                            {/* Googain Company Section */}
                            {(props.customerid === 'googain' ||
                                props.customerid === 'gmcc') &&
                                companyInfo.ShowCompanyInfo && showCompanyInfo && (
                                    <div ref={myCompanyRef}>
                                        <MyCompany
                                            aboutInfo={aboutInfo}
                                            loanOfficerEmail={
                                                basicInfo?.loemail
                                            }
                                            companyInfo={companyInfo}
                                            customerID={props.customerid}
                                        />
                                    </div>
                                )}

                            {/* Reviews Section */}
                            {props.customerid !== 'googain' &&
                                showTestimonial && (
                                    <div ref={reviewsRef}>
                                        <Reviews
                                            reviewsList={reviewsList}
                                            loanOfficerEmail={
                                                basicInfo?.loemail
                                            }
                                        />
                                    </div>
                                )}

                            {/* FAQ Section */}
                            {showFAQ && (
                                <div ref={faqRef}>
                                    <Faq
                                        faqInfo={aboutInfo.faqInfo}
                                        loanOfficerEmail={basicInfo?.loemail}
                                    />
                                </div>
                            )}

                            {/* Require Callback Section */}
                            <div ref={requireCallbackRef}>
                                <RequireCallback
                                    loid={props.loid}
                                    customerid={props.customerid}
                                    handleSubmit={handleSubmit}
                                    ratesData={ratesData}
                                    isPreviewMode={isEditMode}
                                    loanOfficerEmail={basicInfo?.loemail}
                                />
                            </div>
                        </div>
                    </Card>
                </div>
            </div>

            {/* Back to the top */}
            <div style={{ display: 'flex', gap: '13px', width: '100%' }}>
                <div
                    style={{ minWidth: '256px', width: '256px', flexShrink: 0 }}
                />
                <div
                    className="back-to-top"
                    onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                >
                    <Text
                        style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            lineHeight: '19px',
                            color: '#858585',
                            marginRight: '11px',
                        }}
                    >
                        Back to the top
                    </Text>
                    <img
                        src="/images/arrow-up.svg"
                        alt="Back to the top"
                        style={{ width: '12px', height: '8px' }}
                    />
                </div>
            </div>

            {/* Footer */}
            <RootFooter
                scrollToSection={scrollToSection}
                basicInfo={basicInfo}
                aboutInfo={aboutInfo}
                customerID={props.customerid}
                showedModules={showedModules}
            />
        </div>
        <Button
            className={`floating-back-to-top ${showFloatingButton ? 'visible' : ''}`}
                aria-label="Back to top"
                onClick={scrollToTop}
            >
                Back to top
        </Button>
        </>
    )
}

export default withRouter(LandingPage)
